import { range, uniqueId } from 'lodash-es';
import { memo } from 'react';
import TableSkeleton from './table-skeleton';
import { TableSkeletonListProps } from './types';

const TableSkeletonList = memo(
  ({ rowProps, count, columns }: TableSkeletonListProps) => {
    return (
      <>
        {range(0, count).map(() => (
          <TableSkeleton key={uniqueId()} {...rowProps} columns={columns} />
        ))}
      </>
    );
  }
);

export default TableSkeletonList;
